<template>
  <div class="mt-4">
    <fragment>
      <template v-if="!selected">
        <v-card-text>
          <div class="dashboardServicesCards">
            <template v-for="(requestType, index) in requestTypes">
              <sub-request-type-card
                :key="index"
                :request-type="requestType"
                @select-case-request-type="setSelectedRequestType"
              ></sub-request-type-card>
            </template>
            <v-col cols="12">
              <naj-no-data
                :has-data="requestTypes && requestTypes.length > 0"
                :loading="loading"
              ></naj-no-data>
            </v-col>
          </div>
        </v-card-text>
      </template>
      <template v-else>
        <page-content
          small
          class="content-box"
        >
          <div class="col-12 p-3 tabs-section">
            <request-inquiry
              v-if="selectedRequestType.id === 1"
              @back-to-select-request="selected =false"
              @select-main-request="openPrerequisitesInfoModal"
            ></request-inquiry>
            <main-request-inquiry
              v-else-if="selectedRequestType.id === 2"
              :show-judgement-code-query="false"
              @back-to-select-request="selected =false"
              @select-main-request="openPrerequisitesInfoModal"
            ></main-request-inquiry>
          </div>
        </page-content>
      </template>
      <naj-confirmation
        :show-modal="showPrerequisitesInfoModal"
        :max-width="1000"
        :show-close-btn="false"
        :is-persistent="false"
        :title="selectedRequestType.title"
        @cancel="() => {
          showPrerequisitesInfoModal = false;
        }"
      >
        <template slot="actions">
          <naj-button
            :disabled="!pledged"
            @click="navigateToApplyingNewRequest()"
          >
            {{ local.common.next }}
          </naj-button>
        </template>
        <template slot="message-content">
          <naj-input
            :type-id="formFieldType.checkbox"
            :value.sync="pledged"
            :label="selectedRequestType.shortExplanation"
          ></naj-input>
        </template>
      </naj-confirmation>
    </fragment>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('BankruptcyModule');
import SubRequestTypeCard from './sub-request-type-card.vue';
import RequestInquiry from './request-inquiry.vue';
import MainRequestInquiry from './main-request-inquiry.vue';
import { subRequestType } from '@/modules/bankruptcy/helpers/enum';

export default {
  components: {
    SubRequestTypeCard,
    MainRequestInquiry,
    RequestInquiry,
  },
  data() {
    return {
      loading: false,
      selectedRequestType: {},
      showPrerequisitesInfoModal: false,
      pledged: false,
      showUpdateAttorneyDetailsModal: false,
      formModel: {},
      selected: false,
      selectedRequest: null,
      subRequestTypes: [],
      isSubRequestTarget: false,
    };
  },
  computed: {
    ...mapState({ user: state => state.currentUser }),
    requestTypes() {
      let availableTypes = [subRequestType.VerdictObjectionRequest, subRequestType.AddRepresentative];
      return this.subRequestTypes.filter(rt => rt.isEnabled && availableTypes.includes(rt.id));
    },
  },
  mounted() { this.init(); },
  methods: {
    ...mapActions(['canIssueSubRequest', 'getValidSubRequestsTypes', 'getBankruptcyUserInfo']),
    init() {
      Promise.all([this.getValidSubRequestsTypes(), this.getBankruptcyUserInfo()])
        .then((res) => {
          this.subRequestTypes = res[0].data;
        });
    },
    setSelectedRequestType(requestType) {
      this.selectedRequestType = requestType;
      this.selected = true;
    },
    openPrerequisitesInfoModal(request) {
      this.selectedRequest = request;
      request.subRequestObjectKey ? this.isSubRequestTarget = true : this.isSubRequestTarget = false;
      const params = {
        objectKey: request.objectKey,
        requestType: this.selectedRequestType.id,
        judgementId: request.judgementId,
        judgementCode: request.judgementCode,
        subRequestObjectKey: request.subRequestObjectKey,
      };
      this.loading = true;
      this.canIssueSubRequest(params)
        .then((res) => {
          if (res.data) {
            this.showPrerequisitesInfoModal = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    navigateToApplyingNewRequest() {
      this.showPrerequisitesInfoModal = false;
      let queryParams = '';
      if (this.selectedRequest.judgementCode)
        queryParams = `?judgementCode=${this.selectedRequest.judgementCode}`;
      if (this.isSubRequestTarget) {
        this.$router.push({ path: `/bankruptcy/${this.selectedRequest.objectKey}/bankruptcy-file/sub-request/${this.selectedRequestType.name}/${this.selectedRequest.subRequestObjectKey}/external${queryParams}` });
      }
      else {
        this.$router.push({ path: `/bankruptcy/${this.selectedRequest.objectKey}/bankruptcy-file/${this.selectedRequestType.name}${queryParams}` });
      }

    },
  },
};
</script>
<style scoped>
.about-link {
  color: #144afa;
  display: inline;
}
.content-box {
  padding: 0px !important;
  margin-top: 0px !important;
}
.tabs-section {
  min-height: 600px;
}
</style>